/**
 * Night sky backdrop inspired by MjavadH/4X4-Collection Fantasy/Night sky.
 * Preview image bundled from:
 * https://raw.githubusercontent.com/MjavadH/4X4-Collection/master/Fantasy/Night%20sky/Image.png
 */
export const NIGHT_SKY_BG_URL = '/night-sky-bg.png';

export default function NightSkyBackground() {
  return (
    <>
      <div
        className="pointer-events-none absolute inset-0 bg-[#0e0e0e] bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${NIGHT_SKY_BG_URL})` }}
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute inset-0 bg-[#0B0F19]/60"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/50 via-black/20 to-black/70"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_70%_45%_at_50%_-10%,rgba(16,185,129,0.1),transparent)]"
        aria-hidden="true"
      />
    </>
  );
}
